import React from "react";
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

export default function ButtonSubmit({ id, label, cypressid, ...props }) {
  return (
    <ButtonBasic type='submit' id={id} cypressid={cypressid} {...props}>
      {label}
      <FontAwesomeIcon className='font-icon' icon={faPaperPlane} />
    </ButtonBasic>
  );
}

ButtonSubmit.defaultProps = {
  id: "deq-primary",
  label: "Submit",
  cypressid: "submit"
};
